import React from 'react';
import { motion } from 'framer-motion';

interface Props {
  onSelect: (age: 'little' | 'big') => void;
}

export const AgeSelector: React.FC<Props> = ({ onSelect }) => {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '100vh', padding: '20px', textAlign: 'center'
    }}>
      {/* Stars background */}
      <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
        {[...Array(20)].map((_, i) => (
          <motion.div key={i}
            animate={{ y: [0, -20, 0], opacity: [0.3, 1, 0.3] }}
            transition={{ duration: 2 + i * 0.3, repeat: Infinity, delay: i * 0.2 }}
            style={{
              position: 'absolute', fontSize: '20px',
              left: `${Math.random() * 100}%`, top: `${Math.random() * 100}%`
            }}>
            {['⭐', '🌟', '✨'][i % 3]}
          </motion.div>
        ))}
      </div>

      <motion.div initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', duration: 0.8 }} style={{ position: 'relative', zIndex: 1 }}>

        {/* Mālik photo */}
        <motion.div animate={{ y: [0, -12, 0] }} transition={{ duration: 2, repeat: Infinity }}
          style={{ marginBottom: '20px' }}>
          <img src="/malek.jpg" alt="Mālik"
            style={{ width: '140px', height: '140px', borderRadius: '50%', objectFit: 'cover', objectPosition: 'top',
              border: '5px solid #FF6B6B', boxShadow: '0 8px 30px rgba(255,107,107,0.4)' }} />
        </motion.div>

        <h1 style={{
          fontFamily: "'Fredoka One', cursive", fontSize: 'clamp(2.5rem, 8vw, 4rem)',
          color: 'var(--primary)', marginBottom: '10px',
          textShadow: '3px 3px 0px rgba(255,107,107,0.3)'
        }}>
          Learn with Mālik!
        </h1>
        <p style={{ fontSize: '1.3rem', color: 'var(--text-light)', marginBottom: '50px' }}>
          🌙 تعلّم العربية مع مالك 🌙
        </p>

        <p style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--text)', marginBottom: '30px' }}>
          How old are you? كم عمرك؟
        </p>

        <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', justifyContent: 'center' }}>
          {[
            { label: 'Little Explorer', sub: '3 – 6 years', emoji: '🐣', age: 'little' as const, color: '#FF6B6B' },
            { label: 'Big Learner', sub: '6 – 12 years', emoji: '🦅', age: 'big' as const, color: '#6C63FF' },
          ].map((opt) => (
            <motion.button key={opt.age} onClick={() => onSelect(opt.age)}
              whileHover={{ scale: 1.08, y: -5 }} whileTap={{ scale: 0.95 }}
              style={{
                background: 'white', border: `4px solid ${opt.color}`,
                borderRadius: '24px', padding: '30px 40px',
                cursor: 'pointer', boxShadow: `0 8px 30px ${opt.color}40`,
                minWidth: '200px'
              }}>
              <div style={{ fontSize: '60px', marginBottom: '10px' }}>{opt.emoji}</div>
              <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: '1.4rem', color: opt.color }}>
                {opt.label}
              </div>
              <div style={{ fontSize: '0.9rem', color: 'var(--text-light)', marginTop: '5px' }}>
                {opt.sub}
              </div>
            </motion.button>
          ))}
        </div>
      </motion.div>
    </div>
  );
};
